module.exports = __webpack_public_path__ + "img/chr_ts_13.40f5f101.png";